import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import './index.css';

// Configure Amplify with fallback values for local development
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID || 'ap-south-1_YISXiXqKR',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '1j52kjll0f7dc75jovjc9pf15b',
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID || 'ap-south-1:31d8776f-8cc2-4817-b68f-1f934eb65d61',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
